import React from "react";
import styled from "styled-components";

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 1px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox", required: true })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 56px;
  margin: -1px 28px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 56px;
  height: 56px;
  border: 2px solid #4f196f;
  background-color: ${(props) => (props.checked ? "#4f196f" : "")};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px #3898ec;
  }

  ${HiddenCheckbox}:hover + & {
    cursor: pointer;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

const Checkbox = ({ className, checked, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="-15 -15 56 56">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2814 1.42159C24.3259 0.231785 26.1222 0.188235 27.2168 1.34449C28.1315 2.31076 28.2339 3.77306 27.5799 4.85145L27.5459 4.9075L27.3307 5.20119L12.0714 22.5837C11.2055 23.5701 9.78644 23.7938 8.67695 23.1033L8.61252 23.0632L8.30019 22.822L0.893372 15.8332C-0.191946 14.8092 -0.292199 13.0912 0.613482 11.9361C1.4668 10.8478 2.97504 10.5677 4.14187 11.3191L4.20072 11.357L4.48787 11.5823L9.88829 16.6764L23.2814 1.42159C23.2814 1.42157 23.2813 1.42162 23.2814 1.42159Z"
          fill="white"
        />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);

export default Checkbox;
